// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","810":"component---src-pages-[code]-tsx"}[chunkId] + "-" + {"245":"49d1eff8076e2c3b274d","810":"6b2879bd1cb6e66b6e77"}[chunkId] + ".js";
};